import {
    StyleSheet,
    Image,
    View
} from "react-native";
import brandLogoSource from "./assets/logo.svg";
import {
    type NCoreUIKitIcon,
    NCoreUIKitTheme,
    Sidebar,
    Avatar,
    Text
} from "ncore-ui-kit";
import {
    useDocsI18n
} from "../i18n";
import {
    ChevronsUpDown
} from "lucide-react-native";
import {
    createKitIcon
} from "../components/kitIcons";

const BRAND_LOGO = {
    uri: brandLogoSource
};

const ChevronsUpDownIcon = createKitIcon(ChevronsUpDown);

const stylesheet = StyleSheet.create({
    mark: {
        flexDirection: "row",
        alignItems: "center"
    }
});

export const BrandLogoIcon: NCoreUIKitIcon = ({
    size
}) => <Image
    source={BRAND_LOGO}
    aria-hidden={true}
    style={{
        height: size,
        width: size
    }}
/>;

export const BrandMark = () => {
    const {
        t
    } = useDocsI18n();

    const {
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext();

    return <View
        style={[
            stylesheet.mark,
            {
                gap: spaces.spacingSm
            }
        ]}
    >
        <Image
            accessibilityLabel={t("blocks.brandLogo")}
            style={{
                height: iconSizes.large,
                width: iconSizes.large
            }}
            source={BRAND_LOGO}
        />
        <Text
            variant="titleMediumSize"
            color="high"
        >
            {t("blocks.brandName")}
        </Text>
    </View>;
};

export const SidebarBrand = () => {
    const {
        t
    } = useDocsI18n();

    return <Sidebar.MenuButton
        title={t("blocks.brandName")}
        icon={BrandLogoIcon}
    />;
};

export const useSidebarHeaderOffset = ({
    rowHeight
}: {
    rowHeight: number;
}) => {
    const {
        controlHeights,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext();

    return borders.line + spaces.spacingMd + (controlHeights.medium - rowHeight) / 2;
};

export const WorkspaceSwitcher = ({
    onPress
}: {
    onPress?: () => void;
}) => {
    const {
        t
    } = useDocsI18n();

    const {
        controlHeights
    } = NCoreUIKitTheme.useContext();

    const headerOffset = useSidebarHeaderOffset({
        rowHeight: controlHeights.large
    });

    return <Sidebar.MenuButton
        accessibilityLabel={t("blocks.workspace.switch")}
        renderIcon={() => <Avatar
            title={t("blocks.workspace.name")}
            size="xSmall"
        />}
        subTitle={t("blocks.workspace.plan")}
        title={t("blocks.workspace.name")}
        endIcon={ChevronsUpDownIcon}
        style={{
            marginTop: headerOffset
        }}
        aria-haspopup="menu"
        onPress={onPress}
        size="large"
    />;
};
